import { List } from '@mui/material';
import { FC } from 'react';
import { Connection } from '@/types/connection';
import { PortOption } from '@/types/metadata/metadata';
import FixedListItem from './FixedListItem';

type QueueListProps = {
  id: number;
  portOption: PortOption;
  connections: Connection[];
  onArrowClick: (data: Connection[]) => void;
  updateAddConnection: (newConnection: Connection) => void;
};

const QueueList: FC<QueueListProps> = (props) => {
  return (
    <List subheader='Queue Connections' sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {props.connections?.map((connection, index) => (
        <FixedListItem
          key={`${connection.action}.${index}`}
          action={connection.action}
          label={connection.label}
          data={props.connections}
          index={index}
          onArrowClick={props.onArrowClick}
          onChange={(label) => {
            props.updateAddConnection({ ...connection, label: label });
          }}
        />
      ))}
    </List>
  );
};

export default QueueList;
